import React from "react";
import Header from "../../../components/landingPage/Header";
import { useSelector } from "react-redux";
import SideBar from "../../../components/b2b/SideBar";
import { DocsSidebar } from "./DocsSidebar";

import DescriptionV2 from "./DescriptionV2";


const MainDocs = () => {
  const { token } = useSelector((state) => state.auth);

  return (
    <div className="h-screen w-screen fixed">
      <Header token={token} />
      <div className="flex w-full h-full ">
        <SideBar />
        <div className="flex w-full h-full ">
          <div className="w-1/4 h-full">
            <DocsSidebar />
          </div>
          <div className="w-1/2 2lg:w-[54%] xl:w-[63%] xl-2:w-[70%] 2xl:w-3/4 bg-white mt-2">
            <div className="px-4 xl:px-6 pt-4 pb-44 h-full overflow-y-scroll scrollbar">
              <DescriptionV2 />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainDocs;
